import React, { useContext } from "react";
import CertificationContext from "module/certification/context/CertificationContext";
import { CertificationInterface } from "module/certification/types";
import CertificationCertifierLabelField from "./CertificationCertifierLabelField";

const CertificationCertifierFieldContainer: React.FC = () => {
  const { entity } = useContext(CertificationContext);
  const { internalCertifierId, externalCertifier } =
    entity as CertificationInterface;

  return (
    <CertificationCertifierLabelField
      {...{ internalCertifierId, externalCertifier }}
    />
  );
};

export default React.memo(CertificationCertifierFieldContainer);
